import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { appActions } from '../../app/reducer/app-reducer';

//*********************************************
export class Logout extends PureComponent {
  componentWillMount = () => {
    this.props.logoutUser();
  };

  render = () => {
    return null;
  };
}

const mapStateToProps = (state, ownprops) => ({});

const wrapActions = { logoutUser: appActions.logoutUser };
export const LogoutContainer = connect(
  mapStateToProps,
  wrapActions
)(Logout);



// WEBPACK FOOTER //
// ./src/modules/login/components/Logout.jsx